import {combineLatest, debounce, of, switchMap, timer} from 'rxjs';
import {distinctUntilChanged, map, takeUntil, tap} from 'rxjs/operators';
import {LoadingController} from '@ionic/angular';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {
    selectCampaignsLoading,
    selectCharactersLoading,
    selectPlayersLoading,
    selectStoryLoading,
    websocketClosed,
    websocketOpened
} from 'gamesis-state';
import {Store} from '@ngrx/store';
import {Injectable} from '@angular/core';
import {NGXLogger} from 'ngx-logger';

@Injectable()
export class LoadingEffect {
    private loadingEL: HTMLIonLoadingElement;

    loading$ = createEffect(() =>
        this.actions$.pipe(
            ofType(websocketOpened),
            switchMap(_ => combineLatest([
                    this.store.select(selectCampaignsLoading),
                    this.store.select(selectCharactersLoading),
                    this.store.select(selectPlayersLoading),
                    this.store.select(selectStoryLoading)
                ]).pipe(
                    takeUntil(this.actions$.pipe(ofType(websocketClosed))),
                    map(values => values.some(v => v)),
                    debounce(loading => loading ? timer(300) : of({})),
                    distinctUntilChanged(),
                    tap(async (loading) => {
                        this.logger.debug(`loading ${loading}`);

                        if (this.loadingEL) {
                            await this.loadingEL.dismiss();
                            this.loadingEL = undefined;
                        }

                        if (loading) {
                            this.loadingEL = await this.loadingCtrl.create({
                                backdropDismiss: true,
                                spinner: 'crescent',
                                cssClass: 'gamesis'
                            });
                            await this.loadingEL.present();
                        }
                    })
                )
            )
        ), {dispatch: false}
    );

    constructor(private loadingCtrl: LoadingController,
                private actions$: Actions,
                private store: Store,
                private logger: NGXLogger) {
    }
}
